import React from 'react';
import { Spinner } from "@themesberg/react-bootstrap";

export default (props) => {

  const { show } = props;

  return (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "10vh" }}>
      <Spinner animation="border" role="status" style={{ color: "#4a5e79" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};
